import script from "./rec-filter-bar.vue?vue&type=script&lang=ts&setup=true"
export * from "./rec-filter-bar.vue?vue&type=script&lang=ts&setup=true"

import "./rec-filter-bar.vue?vue&type=style&index=0&id=927cebc0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-927cebc0"]])

export default __exports__